import React, { useState, useEffect, useReducer, useRef } from 'react';
import { SFuncModal } from 'shj-components'
import { Form, Button, Select, Divider, Row, Col, message, Table, Input } from 'antd';
import {getExpressVariables, runExpressVariables} from '@/services/integrationConfig'
// @ts-ignore
export function modalExpressRunFn(formula) {
  const onClose = () => {
    dialog.destroy();
  };

  const dialog = SFuncModal({
    title: `结果演算`,
    width: 600,
    vanish: true,
    zIndex: 99999,
    content: <ModalDetails onClose={onClose} formula={formula} />,
  });

  return dialog;
}

// @ts-ignore
const ModalDetails = ({ onClose, formula }) => {
  const [form] = Form.useForm();
  const [addOrEditFooterLoading, setAddOrEditFooterLoading] = useState(false);
  const [expressList, setExpressList] = useState([] as any[]);
  const [result, setResult] = useState('');

  useEffect(() => {
    initFn();
  }, []);

  const initFn = () => {
    console.log(formula);
    let newFormula = formula.replace('.', '．');
    let data = {
      express: newFormula,
    };
    getExpressVariables(data).then((resp: any) => {
        setExpressList(resp);
      });
  };
  // 提交
  const onFinish = (values: any) => {
    let params = [];
    for (let m in values) {
      let obj = {
        paramName: m,
        paramVal: values[m],
      };
      params.push(obj);
    }
    setAddOrEditFooterLoading(true);
    let newFormula = formula.replace('.', '．');
    runExpressVariables({
      express: newFormula,
      params: params,
    }).then((resp: any) => {
        setAddOrEditFooterLoading(false);
        setResult(resp);
      })
      .finally(() => {
        setAddOrEditFooterLoading(false);
      });
  };
  const formItemLayout = {
    labelCol: { span: 7 },
    wrapperCol: { span: 12 },
  };
  return (
    <div style={{ paddingBottom: '40px', padding: 15  }}>
      <Form form={form} onFinish={onFinish}>
        {(expressList || []).map((item: any) => (
          <Form.Item key={item} label={item} name={item} {...formItemLayout}>
            <Input />
          </Form.Item>
        ))}
        <Form.Item>
          <Row>
            <Col span={24}>
              <Divider />
            </Col>
            <Col span={24} style={{ textAlign: 'center' }}>
              <Button htmlType="button" onClick={onClose} style={{ marginLeft: '8px' }}>
                取消
              </Button>
              <Button type="primary" htmlType="submit" style={{ margin: '0 8px' }} loading={addOrEditFooterLoading}>
                运行
              </Button>
            </Col>
          </Row>
        </Form.Item>
      </Form>
      <Divider />
      <div>计算结果：</div>
      <div style={{ paddingTop: 20 }}>{result}</div>
    </div>
  );
};
